import React from 'react'

export default function SimpleCheckbox({
    className,
    label,
    ...props
}: {
    className?: string
    label: string
} & React.InputHTMLAttributes<HTMLInputElement>) {
    const { id, ...rest } = props

    return (
        <div>
            <label htmlFor={id} className={'inline-flex items-center gap-1.5'}>
                <input
                    type="checkbox"
                    data-slot="control"
                    id={id}
                    {...rest}
                    className={'rounded border border-stone-300 text-stone-600 shadow-sm focus:ring-stone-400'}
                />
                <div
                    className={'inline text-base/6 font-medium text-stone-700 select-none data-disabled:opacity-50 sm:text-sm/6'}
                    dangerouslySetInnerHTML={{ __html: label }}
                />
            </label>
        </div>
    )
}
